import React, { Component } from 'react';
import { Form, Input, Modal, Table } from 'antd';

const type = ['全部人员', '部门', '项目'];

class ModalApportion extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  columns = () => {
    return [
      {
        title: '预算来源',
        dataIndex: 'originName',
        width: 100,
      },
      {
        title: '来源类型',
        dataIndex: 'originType',
        render: text => <span>{type[text]}</span>,
        width: 100,
      },
      {
        title: '金额',
        dataIndex: 'price',
        width: 160,
        render: (text, record, index) => {
          return (
            <div>
              {record.isEditable ? (
                <Input value={text} onChange={() => this.handlePriceChange(record)} />
              ) : (
                <span>{text}</span>
              )}
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { details, visible } = this.props;
    return (
      <Modal
        width={900}
        title="查看发放详情"
        visible={visible}
        footer={false}
        onCancel={() => this.props.onCancel(false)}
      >
        <Table
          bordered
          rowKey="originUuid"
          columns={this.columns()}
          dataSource={details}
          scroll={{ y: 260 }}
          size="small"
        />
      </Modal>
    );
  }
}

export default Form.create()(ModalApportion);



// WEBPACK FOOTER //
// ./src/components/hr/bonus/ModalTable.js